const MERCHANT_SLUG_PREFIX = 'm_';

export function toMerchantSlug(uuid: string): string {
    return `${MERCHANT_SLUG_PREFIX}${uuid}`;
}

export function parseMerchantSlug(slug: string): string {
    return slug.slice(MERCHANT_SLUG_PREFIX.length);
}

// Swaps (or, given undefined, removes) the merchant slug in an app path, keeping any
// /staff prefix, query and hash.
export function withMerchantSlug(path: string, merchantSlug: string | undefined): string {
    const unscopedPath = path.replace(/^(\/staff(?=\/|$))?\/m_[^/?#]+/, '$1');

    return merchantSlug === undefined ? unscopedPath : unscopedPath.replace(/^(\/staff(?=\/|$))?/, `$1/${merchantSlug}`);
}
